module.exports = __webpack_public_path__ + "img/logo-2.81185a2a.png";